import React, { useState, useEffect, useContext } from "react";
import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import AuthContext from "../context/AuthContext";
import {
  ArbeitsplanType,
  Terminarten,
  ThreadType,
  TopicType,
  UserType,
} from "../utils/types";
import ArbeitsplanContent from "../components/arbeitsplan/ArbeitsplanContent";
import { SubPageTitleWithUnderline } from "../components/common/SubPageTitleWithUnderline";
import { PageWrapper } from "../components/common/PageWrapper";
import Ankundigungen from "../components/Ankundigungen";
import {
  Button,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import ThreadForm from "../components/forum/ThreadForm";
import ThreadListItem from "../components/forum/ThreadListItem";
import { Link, useNavigate } from "react-router-dom";
import MessageIcon from "@mui/icons-material/Message";
import moment from "moment";

const HomePage = () => {
  const navigate = useNavigate();
  // initalize component state
  const [threads, setThreads] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [topThreads, setTopThreads] = useState<ThreadType[]>([]);
  const [arbeitsplane, setArbeitsplane] = useState<ArbeitsplanType[]>([]);
  const [dauerNachrichten, setDauerNachrichten] = useState<ArbeitsplanType[]>(
    []
  );
  const [wochenendarbeit, setWochenendarbeit] = useState<ArbeitsplanType[]>([]);
  const [topics, setTopics] = useState<TopicType[]>([]);

  useEffect(() => {
    const getTopThreads = async () => {
      // fetch top threads
      const response = await fetch(`/api/topThreads/`);
      const data = await response.json();
      setTopThreads(data);
    };
    getTopThreads();
  }, []);

  useEffect(() => {
    const getThreads = async () => {
      const response = await fetch(`/api/threads/?page=1`);
      const data = await response.json();
      setThreads(data.results);
      if (data.next === null) {
        setHasMore(false);
      }
    };
    const getTopThreads = async () => {
      const response = await fetch(`/api/topThreads/`);
      const data = await response.json();
      setTopThreads(data);
    };
    getTopThreads();
    getThreads();
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const fetchTopics = async () => {
      const response = await fetch("/api/topics/");
      const data = await response.json();
      setTopics(data);
    };

    fetchTopics();
  }, []);

  // fetch next page threads
  const getMoreThreads = async () => {
    const response = await fetch(`/api/threads/?page=${page}`);
    const data = await response.json();
    return data.results;
  };

  const fetchData = async () => {
    const moreThreads = await getMoreThreads();
    setThreads([...threads, ...moreThreads]);
    if (moreThreads.length === 0 || moreThreads.length < 4) {
      setHasMore(false);
    }
    setPage(page + 1);
  };

  let { user } = useContext(AuthContext);
  let currentUser: UserType = user;
  const mbKennung = user != null ? currentUser.mitarbeiternummer : null;
  useEffect(() => {
    const getArbeitsplan = async () => {
      const response = await fetch(`/api/getArbeitsplan/`, {
        cache: "no-cache",
      });
      const data = await response.json();
      setArbeitsplane(data);
      setDauerNachrichten(
        data.filter((ap) => ap.terminart === Terminarten.Dauernachricht)
      );
      setWochenendarbeit(
        data.filter((ap: ArbeitsplanType) => {
          const date = moment(ap.datum);
          return (
            date.isoWeekday() > 5 &&
            ap.mitarbeiter.includes(mbKennung.toString()) &&
            date.isBetween(moment(), moment().add(10, "days"), "day", "[]")
          );
        })
      );
    };

    getArbeitsplan();
  }, []);
  return (
    <PageWrapper>
      {dauerNachrichten.length > 0 &&
        dauerNachrichten.map((ap, index) => (
          <div
            key={index}
            style={{
              marginBottom: "1rem",
              textAlign: "center",
            }}
          >
            {ap.bemerkung
              ?.split("\\n")
              .map((line, index) => (
                <Typography key={index}>{line}</Typography>
              ))}
          </div>
        ))}
      {wochenendarbeit.length > 0 && (
        <div
          style={{
            marginBottom: "1rem",
            textAlign: "center",
          }}
        >
          {wochenendarbeit.map((ap, index) => (
            <Typography color={"red"} key={index}>
              Wochenendarbeit: {moment(ap.datum).format("dddd, DD.MM.YYYY")}
            </Typography>
          ))}
        </div>
      )}

      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <div className="ankundigungen">
            <SubPageTitleWithUnderline title="Ankündigungen" />

            <Ankundigungen data={arbeitsplane} />
          </div>
        </Grid>

        <Grid item xs={12} md={12}>
          <div className="arbeitsplane">
            <SubPageTitleWithUnderline title="Dein Arbeitsplan" />

            <ArbeitsplanContent
              data={arbeitsplane}
              mbNummer={mbKennung}
              showArbeitsplane={true}
            />
          </div>
        </Grid>

        <Grid
          item
          xs={12}
          md={5}
          sx={{
            display: { md: "block" },
          }}
        >
          <SubPageTitleWithUnderline title="Beliebte Diskussionen" />
          {topThreads.map((thread, index) => (
            <Box sx={{ minWidth: 275, marginTop: 2 }} key={index}>
              <Link
                to={`/threads/${thread.id}`}
                style={{ textDecoration: "none", color: "black" }}
              >
                <Card className="hotTopics" variant="outlined" key={index}>
                  <React.Fragment>
                    <CardContent>
                      <Typography variant="h6" component="div">
                        {thread?.subject}
                      </Typography>
                      <Typography sx={{ mb: 1.5 }} color="text.secondary">
                        {typeof thread?.creator === "string" ? thread.creator : thread?.creator?.username}
                      </Typography>
                      <Typography variant="body2" color="text.primary">
                        <MessageIcon sx={{ marginRight: 1 }} />
                        {thread?.replyCount}
                      </Typography>
                    </CardContent>
                  </React.Fragment>
                </Card>
              </Link>
            </Box>
          ))}
        </Grid>

        <Grid item xs={12} md={5}>
          <SubPageTitleWithUnderline title="Neueste Nachrichten">
            <Button
              variant="outlined"
              onClick={() => navigate("/forum")}
              style={{
                maxWidth: "180px",
                maxHeight: "32px",
                minWidth: "100px",
                minHeight: "32px",
              }}
            >
              Zum Forum
            </Button>
          </SubPageTitleWithUnderline>
          <div>
            {threads.map((thread, index) => (
              <ThreadListItem key={index} thread={thread} />
            ))}
            {hasMore && (
              <ListItemButton
                onClick={fetchData}
                style={{ width: "100%", marginTop: "20px" }}
              >
                Lade mehr Beiträge...
              </ListItemButton>
            )}
            {!hasMore && (
              <ListItem>
                <p style={{ textAlign: "center", marginTop: 20 }}>
                  <span>Du hast alle Beiträge gesehen.</span>
                </p>
              </ListItem>
            )}
          </div>
        </Grid>
        <Grid
          item
          md={2}
          sx={{
            display: { xs: "none", md: "block" },
          }}
        >
          <SubPageTitleWithUnderline title="Themen" />

          <List
            sx={{
              width: "100%",
              maxWidth: 360,
              bgcolor: "background.paper",
            }}
            aria-label="topics"
          >
            {topics
              .sort((a, b) => a.label.localeCompare(b.label))
              .map((topic, index) => (
                <div key={index}>
                  <Link
                    style={{
                      textDecoration: "none",
                      color: "black",
                      textTransform: "capitalize",
                    }}
                    to={`/topic/${topic.id}`}
                  >
                    <ListItem key={index}>
                      <ListItemButton>
                        <ListItemText
                          primary={<Typography>{topic.label}</Typography>}
                        />
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </div>
              ))}
          </List>
        </Grid>
      </Grid>

      {/* <Grid item xs={12} md={6}>
    <SubPageTitleWithUnderline title="Ideenbox" />
    <p>
      Hier könnte die Funktion enstehen, anonym Vorschläge zu machen
    </p> */}
      {/* {userRole !== 8 && <KKasten />} Reactivate
      {userRole === 8 && <Beschwerden />} */}
      {/* </Grid> */}
    </PageWrapper>
  );
};

export default HomePage;
